module.exports = __webpack_public_path__ + "images/emoji/sunglasses.4c43467603ddf68a5edb.png";